// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvisoryPositionMatchCountController from "./advisory_position_match_count_controller"
application.register("advisory-position-match-count", AdvisoryPositionMatchCountController)

import AutoRequestController from "./auto_request_controller"
application.register("auto-request", AutoRequestController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BulkDealSelectController from "./bulk_deal_select_controller"
application.register("bulk-deal-select", BulkDealSelectController)

import CheckableController from "./checkable_controller"
application.register("checkable", CheckableController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClickableController from "./clickable_controller"
application.register("clickable", ClickableController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CountUpAnimationController from "./count_up_animation_controller"
application.register("count-up-animation", CountUpAnimationController)

import DealMatchChartController from "./deal_match_chart_controller"
application.register("deal-match-chart", DealMatchChartController)

import DealPrintController from "./deal_print_controller"
application.register("deal-print", DealPrintController)

import DisabledController from "./disabled_controller"
application.register("disabled", DisabledController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FileDropZoneController from "./file_drop_zone_controller"
application.register("file-drop-zone", FileDropZoneController)

import FilePreviewsController from "./file_previews_controller"
application.register("file-previews", FilePreviewsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HiddenController from "./hidden_controller"
application.register("hidden", HiddenController)

import IndustrySmallSectorSelectionController from "./industry_small_sector_selection_controller"
application.register("industry-small-sector-selection", IndustrySmallSectorSelectionController)

import MessageTemplateSelectorController from "./message_template_selector_controller"
application.register("message-template-selector", MessageTemplateSelectorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PrefectureSelectionController from "./prefecture_selection_controller"
application.register("prefecture-selection", PrefectureSelectionController)

import RecaptchaSubmitController from "./recaptcha_submit_controller"
application.register("recaptcha-submit", RecaptchaSubmitController)

import RefineMessageController from "./refine_message_controller"
application.register("refine-message", RefineMessageController)

import RequestOnSelectController from "./request_on_select_controller"
application.register("request-on-select", RequestOnSelectController)

import RequireOnSelectOtherOptionController from "./require_on_select_other_option_controller"
application.register("require-on-select-other-option", RequireOnSelectOtherOptionController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectForceValueController from "./select_force_value_controller"
application.register("select-force-value", SelectForceValueController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TextcompleteController from "./textcomplete_controller"
application.register("textcomplete", TextcompleteController)

import ToggleClassController from "./toggle_class_controller"
application.register("toggle-class", ToggleClassController)

import ToggleDisabledController from "./toggle_disabled_controller"
application.register("toggle-disabled", ToggleDisabledController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)
